<div class="ziro-admin-page-content">
  <ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>

  <div class="col-md-10 offset-md-1 pb-2" [hidden]="isLoading">
    <ziro-breadcrumbs>
      <ziro-breadcrumb-card-item>
        <div [innerHTML]="'tkey;admin.system.oauth2_resource_server_management.description' | escapeHtml"></div>
      </ziro-breadcrumb-card-item>
    </ziro-breadcrumbs>

    @if (showDefaultsAlert) {
      <div class="alert alert-info">
        <div [innerHTML]="'tkey;admin.system.oauth2_resource_server_management.alert.header' | escapeHtml"></div>
        <div>
          <p [innerHTML]="'tkey;admin.system.oauth2_resource_server_management.alert.text_1' | escapeHtml"></p>
          <div class="mb-2" data-automation="default-jwt-issuer">
            <strong>
              {{ 'tkey;admin.system.oauth2_resource_server_management.issuer.label' | translate }}
            </strong>
            <code class="bg-dark-subtle text-muted ms-2 p-1">
              {{ oauth2ResourceServerSettingsDefaults.jwtIssuerUrl }}
            </code>
          </div>
          <div data-automation="default-audience">
            <strong>
              {{ 'tkey;admin.system.oauth2_resource_server_management.audience.label' | translate }}
            </strong>
            <code class="bg-dark-subtle text-muted ms-2 p-1">
              {{ oauth2ResourceServerSettingsDefaults.audience }}
            </code>
          </div>
        </div>
      </div>
    }

    <div class="mb-3 list-group list-group-striped border-rad-all-12 card-shadow">
      @for (fieldId of fieldIds; track fieldId) {
        <div class="list-group-item position-relative">
          <ziro-general-settings-text [fieldId]="fieldId"></ziro-general-settings-text>
        </div>
      }
    </div>
  </div>
</div>

<ziro-bottom-nav></ziro-bottom-nav>
